<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSlidebar || mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = isShowLeftSlidebar = false"
    />

    <portal to="content-renderer-sidebar-left">
      <left-view
        :list-data="listData"
        :curData="currentData"
        :isShowEdit.sync="isShowLeftSlidebar"
        :isShowMe.sync="mqShallShowLeftSidebar"
        @show-left-slidebar="showLeftSlidebar"
        @show-detail-data="showDetailData"
        @reload-list="getListData"
        @update-current="updateCurrentData"
      />
    </portal>

    <section class="chat-app-window">
      <content-view
        :curData="currentData"
        :items="listChild"
        @reload-list="getListData"
        @set-mq-shall-show-left-sidebar="setMqShallShowLeftSidebar"
      />
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import store from "@/store";
import { ref } from "@vue/composition-api";
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BInputGroupPrepend,
  BFormCheckbox,
  BBadge,
  BButtonGroup,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import { useResponsiveAppLeftSidebarVisibility } from "@core/comp-functions/ui/app";

import LayoutData from "@/layouts/LayoutData";

import {
  GetAll as getRoles,
  GetById,
  RolesCreate,
  RolesUpdate,
  RolesDelete,
} from "@/services/api/DefaultTemplate/RoleService";

import { GetAll as getAction } from "@/services/api/DefaultTemplate/MenuService";

import ContentView from "./components/ContentView.vue";
import LeftView from "./components/LeftView.vue";

export default {
  components: {
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,
    draggable,
    BFormCheckbox,
    BBadge,
    BInputGroupPrepend,
    BButtonGroup,

    VuePerfectScrollbar,

    ContentView,
    LeftView,
  },
  data() {
    return {
      isWait: false,
    };
  },
  methods: {
    getListData() {
      getRoles().then((res) => {
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          console.log(res);
          this.listData = res.data;
          //   this.listChild = res.data.groupModules;

          //   if (this.currentData && this.listData.length > 0) {
          //     let index = this.listData.findIndex(
          //       (el) => el.id == this.currentData.id
          //     );
          //     if (index != -1) {
          //       this.currentData = {};
          //     } else {
          //       var data = this.listData[0];
          //       this.currentData = JSON.parse(JSON.stringify(data));
          //       this.showDetailData(this.currentData);
          //     }
          //   } else {
          //     this.currentData = {};
          //   }
        }
      });
    },
    getListAction() {
      getAction().then((response) => {
        this.listChild = response.data;
        console.log("listChild======", this.listChild);
      });
    },
  },
  created() {
    this.getListData();
    this.getListAction();
  },
  setup(props, { emit }) {
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Roles";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    const listData = ref([]);
    const currentData = ref({});
    const listChild = ref([]);

    const isShowLeftSlidebar = ref(false);
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility();
    const setMqShallShowLeftSidebar = (data) => {
      mqShallShowLeftSidebar.value = data;
    };

    const showLeftSlidebar = (data) => {
      currentData.value = JSON.parse(JSON.stringify(data));
      isShowLeftSlidebar.value = true;
    };
    const showDetailData = (data) => {
      currentData.value = JSON.parse(JSON.stringify(data));
      mqShallShowLeftSidebar.value = false;
    };

    const updateCurrentData = (data) => {
      currentData.value = data; //JSON.parse(JSON.stringify(data))
    };

    return {
      listData,
      currentData,
      listChild,
      showLeftSlidebar,
      showDetailData,
      updateCurrentData,

      isShowLeftSlidebar,
      mqShallShowLeftSidebar,
      setMqShallShowLeftSidebar,
    };
  },
};
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
